import { useEffect, useState } from "react";
import SidePanel from "../../components/SidePanel";
import rightIcon from "../../assets/pic/righticon.svg";
import Spinner from "../../components/Spinner";
import ConfirmationModal from "../../components/ConfirmationModal";
import moment from "moment/moment";
import Modal from "../../components/Modal";
import { IoMdClose } from "react-icons/io";
import { IoCheckmark } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const PlanCard = ({
  quantity,
  price,
  features,
  is_subscribed,
  stripeCustomerId,
  stripPlansinfo,
  basicSubscriptionPlanId,
  planId,
  me = {},
  subscription,
}) => {
  console.log("is_subscribed: ", is_subscribed);
  const [loader, setLoader] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showModel, setShowModel] = useState(false);

  const toggleShowModal = () => {
    setShowModel((prev) => !prev);
  };

  const toggleModal = () => {
    setIsModalVisible((prev) => !prev);
  };

  const handleConfirmUpgrade = () => {
    upgradePlan();
    toggleModal(); // Close the modal
  };
  const handleSubcribe = async () => {
    if (is_subscribed) {
      return;
    }
    setLoader(true);
    const token = localStorage.getItem("token");

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/customer/stripeCheckout`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
        body: JSON.stringify({
          stripeProductId: planId,
        }),
      }
    );
    const data = await res.json();
    setLoader(false);
    if (data.code === 200) {
      window.location.href = data.subscription;
    }
  };
  const [modelLoader, setModelLoader] = useState(false);
  const navigate = useNavigate();

  const handleManageSubscription = async () => {
    if (!stripeCustomerId) {
      return;
    }
    setModelLoader(true);
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/stripePlan/create-portal-session?stripeCustomerId=` +
          stripeCustomerId,
        {
          method: "POST", // Adjust based on your backend requirements
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        // Handle error or invalid response
      }
    } catch (error) {
    } finally {
      setModelLoader(false);
    }
  };
  const handleManageFreeSubscription = async () => {
    setModelLoader(true);
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/delete-customer`,
        {
          method: "DELETE", // Adjust based on your backend requirements
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      if (data.code === 200) {
        localStorage.removeItem("token");
        localStorage.removeItem("ID");
        navigate("/");
      } else {
        // Handle error or invalid response
      }
    } catch (error) {
    } finally {
      setModelLoader(false);
    }
  };

  const handleFreeRedirect = () => {
 
    navigate("/dashboard/card_generation");
  };

  const upgradePlan = async () => {
    if (!stripeCustomerId) {
      return;
    }
    setLoader(true);
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/stripePlan/upgrade_Plane/${planId}/${basicSubscriptionPlanId}`,
        {
          method: "POST", // Adjust based on your backend requirements
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();

      window.location.href = "/dashboard/premium_plan";
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center w-full h-full">
      {isModalVisible && (
        <ConfirmationModal
          title="Upgrade Plan"
          message={`You are upgrading to the $12.95. This plan will activate once your current plan expires.`}
          confirmText="Upgrade"
          cancelText="Cancel"
          onConfirm={handleConfirmUpgrade}
          onCancel={toggleModal}
          toggleModal={toggleModal}
        />
      )}

      <div
        className={`flex lg:flex-row flex-col pb-12 gap-2 mt-6 w-full h-full justify-center  items-center ${
          quantity === "Free Plan" ? "justify-end" : "justify-start"
        }`}
      >
        <div
          className={`w-80 min-h-[400px]  rounded-lg shadow-lg`}
          style={{ ...(quantity === "Free Plan" && { height: "inherit" }) }}
        >
          <div className="w-full h-20 rounded-tl-lg rounded-tr-lg items-center justify-center flex bg-[#F1E3E4] text-[24px]">
            <span className="text-[32px] text-primary font-semibold">
              {quantity === "Single Card Option"
                ? quantity + " "
                : quantity + " Cards"}
            </span>
            <p className="text-[24px] mt-2 font-semibold text-[#2F3649]">
              {quantity === "Single Card Option" ? "" : "/Month"}
            </p>
          </div>
          <div className="p-8 flex flex-col justify-start items-start">
            <span className="text-primary text-[32px] flex font-semibold">
              {price}
              <p className="text-[22px] font-[400px] text-[#2F3649] mt-2">
                {quantity === "Single Card Option" ? "" : "/mo"}
              </p>
            </span>
            <ul className="flex flex-col gap-3 mt-2 font-[400px]">
              {features.map((feature, index) => (
                <span key={index} className="flex gap-2 text-black">
                  <img src={rightIcon} alt=""></img>
                  {feature.feature}
                </span>
              ))}
            </ul>

            {loader ? (
              <div className="flex items-center justify-center w-full">
                <Spinner props=" " size={"80"} />
              </div>
            ) : is_subscribed ? (
              <button
                onClick={() => setShowModel(true)}
                className={`w-full border-2 font-bold mt-4 text-center py-3 bg-primary text-white rounded-md hover:bg-primary-dark duration-300 ease-linear
                   ${quantity === "Free Plan" ? "hidden" : "block"}
                  `}
              >
                Cancel Subscription
              </button>
            ) : (
              <button
                onClick={
                  quantity === "Single Card Option"
                  ? handleFreeRedirect
                    : me?.amount == "12.9"
                    ? toggleModal
                    : handleSubcribe
                }
                className={`w-full border-2 font-bold mt-4 text-center py-3 bg-primary text-white rounded-md hover:bg-primary-dark duration-300 ease-linear ${
                  me?.amount === "12.95" || is_subscribed || me.upgradedAt
                    ? "bg-gray-400 text-white border-gray-400" // Styles for subscribed (disabled) state
                    : "bg-primary text-white " // Styles for active (not subscribed) state
                }
                ${
                  quantity === "Free Plan"
                    ? " mt-[110px]"
                    : "mt-4 hover:border-2 hover:border-primary hover:bg-white hover:text-primary "
                }`}
              >
                {quantity === "Single Card Option"
                  ? "Free"
                  : quantity === "Free Plan"
                  ? "Cancel Subscription"
                  : me?.amount == "12.5"
                  ? me.upgradedAt
                    ? `Activation Date: ${moment(me.upgradedAt).format(
                        "DD-MM-YYYY"
                      )}`
                    : "Upgrade"
                  : "Subscribe"}
              </button>
            )}
          </div>
        </div>
        {/* </div> */}
        {/* ))} */}
      </div>

      {showModel && (
        <Modal toggleRemoveModal={toggleShowModal}>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-secondary w-full h-fit p-2 px-4 py-3 rounded-t-xl rounded-tl-xl flex items-center justify-between">
              <h1 className="text-2xl text-white capitalize">
                {/* {occasion} Confirmation */}
                Subscription Cancel
              </h1>
              <IoMdClose
                size={30}
                color="white"
                className="cursor-pointer"
                onClick={toggleShowModal}
              />
            </div>
            <div className="flex flex-col items-center w-[80%] justify-center p-5 m-10 border-2 border-black border-dashed rounded-lg">
              <p className="my-3 text-lg text-center">
                {quantity === "Free Plan"
                  ? "Are you sure? Your account, along with all your contacts and greeting card information, will be lost."
                  : "Are you sure? All your contact and greeting card information, will be lost."}
              </p>
              <div className="flex items-center justify-center w-full text-xl gap-x-4">
                <button
                  className="flex items-center justify-center px-8 py-2 border-2 rounded-sm border-primary text-primary hover:bg-primary-light gap-x-2"
                  onClick={toggleShowModal}
                >
                  <IoMdClose size={30} />
                  <span className="font-medium">No</span>
                </button>
                {false ? (
                  <div>
                    <Spinner props={""} size={"50px"} />
                  </div>
                ) : (
                  <button
                    onClick={() => {
                      if (is_subscribed) {
                        handleManageSubscription();
                      } else if (quantity === "Free Plan") {
                        handleManageFreeSubscription();
                      }
                    }}
                    className="flex items-center justify-center px-8 py-2 text-white border-2 rounded-sm bg-primary hover:bg-primary-dark border-primary gap-x-2"
                  >
                    {modelLoader ? (
                      <div className="flex items-center justify-center w-full">
                        <Spinner props=" " size={"43"} />
                      </div>
                    ) : (
                      <>
                        <IoCheckmark size={30} />
                        <span className="font-medium">Yes</span>
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

const PremiumPlan = () => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  console.log("isSubscribed: ", isSubscribed);
  const [stripeCustomerId, setstripeCustomerId] = useState(false);
  const [loader, setLoader] = useState(false);
  const [plansLoader, setPlansLoader] = useState(false);
  const [stripPlansinfo, setStripePlansInfo] = useState([]);
  const [subscription, setSubscrition] = useState([]);
  const [me, setMe] = useState({});
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setPlansLoader(true);
        const token = localStorage.getItem("token");
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/stripePlan/get-plans`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await res.json();
        setStripePlansInfo(data.plans);
      } catch (error) {
      } finally {
        setPlansLoader(false);
      }
    };
    fetchPlans();
  }, []);
  useEffect(() => {
    const fetchUserProfile = async () => {
      setLoader(true); // Start loading
      const token = localStorage.getItem("token");
      if (!token) {
        // Handle case where the user is not logged in or the token is not available

        setLoader(false); // Stop loading if there's an error
        return;
      }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/me`,
          {
            // Adjusted to point to a profile endpoint
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await response.json();
        console.log("data: ssss", data);
        if (data) {
          setIsSubscribed(data.detail.isSubscribed);
          setstripeCustomerId(data.detail.stripeCustomerId);
          setSubscrition(data.detail.subscription);
          setMe(data.detail);
        }
      } catch (error) {
      } finally {
        setLoader(false);
      }
    };

    fetchUserProfile();
  }, []);

  const plans = [
    {
      index: 0,
      quantity: "Single Card Option",
      price: "$4.95 / card",
      features: [
        { index: 1, feature: "Unlimited recipients" },
        { index: 2, feature: "Access to message generator" },
        { index: 3, feature: "Full Access to Calendar" },
        {
          index: 4,
          feature: "Receive email reminders of your upcoming events",
        },
        {
          index: 5,
          feature: "Unlimited printed and mailed cards each month",
        },
      ],
      is_subscribed: isSubscribed,
    },

    {
      index: 1,
      quantity: "4",
      price: "$12.95",
      planId:
        stripPlansinfo?.filter((sub) => sub.amount === 12.95)[0]?.id || "",
      basicSubscriptionPlanId:
        subscription?.filter((sub) => sub.amount === "12.5")[0]
          ?.subscriptionID || "",
      features: [
        { index: 11, feature: "$3.25 per Card or $12.95/mo" },
        { index: 21, feature: "Cancel anytime" },
        { index: 31, feature: "Unlimited recipients" },
        { index: 41, feature: "Access to message generator" },
        {
          index: 4,
          feature: "Full Access to Calendar",
        },
        {
          index: 51,
          feature: "Receive email reminders of your upcoming events",
        },
        { index: 61, feature: "4 printed and mailed cards each month" },
      ],
      is_subscribed:
        subscription?.find((sub) => sub.amount === "12.95")?.isSubscribed ||
        false,
    },
  ];

  if (loader || plansLoader) {
    return (
      <section className="flex">
        <SidePanel />
        <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
          <div
            className=" flex items-center justify-center"
            style={{ height: "calc(100vh - 10rem)" }}
          >
            <Spinner props="Loading" size={"80"} />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="flex">
      <SidePanel />
      <div className="w-full flex flex-col justify-center xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
        <h1 className="text-4xl text-secondary font-bold sm:text-left text-center mb-5">
          Subscription Plans
        </h1>

        <div className="my-5 flex flex-col md:flex-row justify-center items-center gap-6 md:gap-20">
          {plans
            .filter((plan) => {
              // If user is subscribed → hide Free Plan card
              if (isSubscribed && plan.quantity === "Single Card Option") {
                return false;
              }
              return true;
            })
            .map((plan, index) => (
              <PlanCard
                key={index}
                planId={plan.planId}
                quantity={plan.quantity}
                price={plan.price}
                features={plan.features}
                is_subscribed={plan.is_subscribed}
                stripeCustomerId={stripeCustomerId}
                basicSubscriptionPlanId={plan.basicSubscriptionPlanId}
                stripPlansinfo={stripPlansinfo}
                subscription={subscription}
                me={me}
              />
            ))}
        </div>
      </div>
    </section>
  );
};

export default PremiumPlan;
